<template>
    <z-basePage :title="'角色设置'">
        <div class="role-main">
            <div class="tip">
                <span>为前台权限</span>
                <span>为后台权限</span>
            </div>
            <div class="left">
                <div class="add">
                    <el-input v-model.trim="inputText" ref="input" placeholder="请输入角色名称"></el-input>
                    <div class="back-btn" @click="addItem">添加</div>
                </div>
                <z-scrollDiv class="list">
                    <div class="name-item" :class="{active:now_roleId === item.id}" v-for="item in role_list_calc" :key="item.id" @click="getRoleData(item.id)">
                        {{ item.displayName }}
                        <span v-if="nameJudge(item.name)"  v-show="now_roleId === item.id" @click.stop="deleteItem">删除</span>
                    </div>
                </z-scrollDiv>
            </div>

            <z-scrollDiv class="right">
                <div class="role-item" v-for="(data,index) in bigData">
                    <div class="title" :class="{front:codeJudge(data) }">
                        <span>{{ data.title }}</span>
                        <el-checkbox :disabled="admin_item.id == now_roleId" :indeterminate='optionLen[index] < data.options.length && optionLen[index]>0' v-model="data.check_all" @change="checkAll(data,$event)"></el-checkbox>
                    </div>
                    <el-checkbox-group class="group" v-model="sub_ids" @change="chooseChange(data,index)">
                        <el-checkbox :disabled="admin_item.id == now_roleId" v-for="item in data.options" :key="item.id"  :label="item.id">{{ item.text }}</el-checkbox>
                    </el-checkbox-group>
                </div>

                <div class="btn-bottom" v-show="admin_item.id != now_roleId">
                    <div class="back-btn blue" :class="{disabled:!now_form.changeFlag}" @click="save">保存</div>
                    <div class="back-btn" :class="{disabled:!now_form.changeFlag}" @click="cancel">取消</div>
                </div>
            </z-scrollDiv>

            <!-- 表单 -->
            <div v-form="'back-role'" v-show="false">
                <input v-tar="sub_ids_str" v-model="sub_ids_str">
            </div>
        </div>
    </z-basePage>
</template>

<script>
    import permission from 'src/config/permission-config.js'

    export default {
        data() {
            return {
                bigData:permission,

                sub_ids:[],  //权限合集
                now_roleId:0,  //当前角色的id
                admin_item:{},  //当前选择的角色

                role_list:[],
                inputText:"",   //新增 角色输入
                now_form:{},  

                test:[1,3,4],
            };
        },
        computed:{
            role_list_calc(){   //重新给 角色列表排个序
                let arr1 = [];
                let arr2 = this.role_list.reduce((arr,role,index)=>{
                    let result = this.nameJudge(role.name); 
                    if(result){
                        arr.push(role)
                    }else{
                        arr1.push(role);
                    }
                    return arr;
                },[]);
                return arr1.concat(arr2);
            },
            optionLen(){  //选项块当前的数量合集数组
                return this.bigData.map(data=>{
                    let count = 0;
                    data.options.map(item=>{
                        if(this.sub_ids.indexOf(item.id)!==-1){
                            count++;
                        }
                    })
                    return count;
                });
            },
            sub_ids_str:{
                get(){
                    return [...this.sub_ids].sort((a,b)=>a-b).join(',');
                },
                set(str){
                    this.sub_ids = str.length?str.split(',').map(val=>parseInt(val)):[];
                }
            },
        },

        filters:{

        },

        created(){
            this.getRoleList();
        },

        mounted(){
            this.now_form = this.$form.forms["back-role"];
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-role',path:to.path});
			next(res);
		},

        methods: {
            // ***渲染和数据
            getRoleList(){   //获取角色列表
                let url = `api/admin/role/list`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.role_list = res.res_data;
                        this.admin_item = this.role_list.filter(item=>item.name == 'admin')[0];
                        this.getRoleData(this.role_list[0].id);
                    }
                })

            },
            getRoleData(id){  //获取特定角色权限数组
                // 保存判断
                // .....

                // if(id == undefined){
                //     this.sub_ids = [];
                //     this.firstRender();
                //     this.$form.init("back-role");
                //     return;
                // }

                this.now_roleId = id;
                let url =  `api/admin/permission/list`;
                this.$http.get(url,{
                    params:{
                        role_id:id,
                    }
                }).then(res=>{
                    if(res.status == 200){
                        // console.log(res.res_data);
                        this.sub_ids = res.res_data.map(item => parseInt(item.permission_id));
                        this.firstRender();
                        this.$form.init("back-role");
                    }
                })
            },
            firstRender(){  //sub_ids直接赋值时，渲染正确的全选按钮
                this.bigData.map((data,index)=>{
                    let len = data.options.length;
                    let i = this.sub_ids.indexOf(data.id);
                    if(i != -1){
                        data.check_all = true;
                    }else{
                        data.check_all = false;
                    }
                });
            },
            codeJudge(data){  //根据code判断权限
                let num = Math.floor(data.code/1000);
                if(num == 1){  //前台权限
                    return true;
                }else if(num == 2){ //后台权限
                    return false;
                }
            },


            // ****角色相关
            addItem(){  //新增角色
                let text = this.inputText;
                if(!text){
                    this.errorTip('角色名不能为空');
                    return;
                }
                if(this.role_list.some(item=>item.display_name === text)){
                    this.errorTip("角色名重复");
                    return;
                }

                let url =`api/admin/role`;
                this.$http.post(url,{
                    role_name:text,
                }).then(res=>{
                    if(res.status == 200){
                        this.role_list.push(res.res_data);
                        // input 清空 
                        this.inputText = "";
                        // 新建的权限表
                        this.getRoleData(res.res_data.id);
                    }
                })
            },
            deleteItem(){  //删除角色
                this.$func.loading(true);
                let url =`api/admin/role/delete`;
                this.$http.post(url,{
                    role_id:this.now_roleId,
                }).then(res=>{
                    if(res.status == 200){
                        this.getRoleList();
                        this.successTip("删除成功");
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.$func.loading(false);   
                })
            },
            nameJudge(name){
                let names = [
                    "admin",
                    "职员权限",
                    "合伙人权限",
                ];
                return names.every(val=>val!=name);
            },

            // *****右侧菜单操作
            checkAll(data,event) {  //点击全选
                data.check_all = event.target.checked;
                let i = this.sub_ids.indexOf(data.id);
                
                if(data.check_all){
                    i == -1 &&  (this.sub_ids.push(data.id));   
                    data.options.map(item=>{
                        if(this.sub_ids.indexOf(item.id) === -1){
                            this.sub_ids.push(item.id);
                        }
                    });
                }else{
                    i != -1 && ( this.sub_ids.splice(i,1));
                    data.options.map(item=>{
                        let index = this.sub_ids.indexOf(item.id);
                        if( index !== -1){
                            this.sub_ids.splice(index,1);
                        }
                    });
                }
            },
            chooseChange(data,index) {  //影响全选按钮效果
                let checkedCount = this.optionLen[index];
                let i = this.sub_ids.indexOf(data.id);
                
                if(checkedCount == 0){  //根据子选项
                    this.sub_ids.splice(i,1);
                }else{
                    i == -1 && ( this.sub_ids.push(data.id));
                }
                data.check_all = checkedCount === data.options.length;
            },

            // ****底部按钮
            save(){
                if(!this.now_form.changeFlag){
                    // this.successTip("保存成功");
                    return;
                }

                if(this.sub_ids_str == ""){
                    this.errorTip("权限不能为空");
                    return;
                }

                this.$func.loading(true);
                let url = `api/admin/permission`;
                this.$http.post(url,{
                    role_id:this.now_roleId,
                    permission_id:this.sub_ids_str,
                }).then(res=>{
                    if(res.status == 200 ){
                        this.getRoleData(this.now_roleId);
                        // this.$func.getUserInfo(true);  //权限更新可能会涉及自己  重新获取自身数据
                        this.successTip("保存成功");
                    }
                    this.$func.loading(false);
                    
                }).catch(err=>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },
            cancel(){
                // console.log(this.$form.reBack("back-role"))
                [this.sub_ids_str] = this.$form.reBack("back-role");
                this.firstRender();
            },

        },

    }
</script>

<style lang="less">
    @import "~src/assets/less/backless/var.less";
    .role-main{
        height:100%;
        box-sizing: border-box;
        padding:20px 0;
        overflow: hidden;
        @left_w:230px;
        position: relative;

        .left{
            float: left;
            width:@left_w;
            height:100%;
            box-sizing: border-box;
            .add{
                overflow: hidden;
                margin-bottom:5px;
                >div{
                    float:left;
                }
                .el-input{
                    min-width:160px;
                    width:160px;
                    margin-right: 10px;
                }
            }
            .list{
                box-sizing: border-box;
                border:1px solid @border_c;
                height:calc(~"100% - 30px - 5px");
            }
        }
        .right{
            float: left;
            height:100%;
            width:calc(~"100% - @{left_w}");
            box-sizing: border-box;
            padding-left: 24px;

            .btn-bottom{
                position: relative;
                margin-top:30px;
                .back-btn+.back-btn{
                    margin-left:20px;
                }

            }
        }

        .tip{
            position: absolute;
            right:0;
            top:0;
            font-size:12px;
            color:@font_tip;
            span{
                &:before{
                    content:"";
                    display: inline-block;
                    height: 8px;
                    width:8px;
                    border-radius: 50%;
                    background:@red;
                    margin-right: 8px;
                }
                &+span{
                    margin-left: 20px;
                }
            }
            span:nth-child(2):before{
                background:@blue;
            }

        }

        // 左侧名字列表
        .name-item{
            height: 34px;
            line-height: 34px;
            font-size:12px;
            padding-left:12px;
            cursor: pointer;
            transition:0.3s;
            span{
                color:#ff8383;
                position: absolute;
                right: 10px;
                transition:0.3s;
                &:hover{
                    transform:translate(-2px);
                    // transform:scale(1.1);
                }
            }

            &.active{
                background:@menu_bg;
            }
            &:hover{
                background:@menu_bg;
            }
        }

        //多选列表
        .role-item{
            line-height: 30px;
            font-size: 12px;
            color:@black;
            &+.role-item{
                margin-top: 20px;
            }
            .title{
                font-weight:600;
                border-bottom:1px solid @border_c;
                &:before{
                    content:"";
                    display: inline-block;
                    height: 8px;
                    width:8px;
                    border-radius: 50%;
                    background:@blue;
                }
                >span{
                    margin:0 5px;
                }

                &.front:before{
                    background:#ff6e6e;
                }
            }

            .group{
                line-height: 50px;
            }

            .el-checkbox__label{
                font-size:12px;
                color:@black;
            }

            .el-checkbox+.el-checkbox{
                margin-left:0;
            }
            .el-checkbox{
                margin-right:15px;
            }

        }
    }
</style>





// WEBPACK FOOTER //
// page-role.vue?8de16606